<template>
  <div class="CarStick">
    <div class="car-stick">
      <div class="in-car-stick">
        <img class="car-img" :src="isFirst?require('@/assets/images/temp/car-stick.png'):img" />
        <!-- 未设计 -->
        <div v-if="isFirst">
          <div class="form" v-if="!state">
            <van-cell-group class="no-border no-back">
              <van-field label="联系人" :placeholder="form.name" type="text" v-model="form.realname"></van-field>
            </van-cell-group>
            <van-cell-group class="no-border no-back">
              <van-field label="联系方式" :placeholder="form.phone" type="text" v-model="form.mobile"></van-field>
            </van-cell-group>
            <van-cell-group class="no-border no-back">
              <van-field label="车牌号" :placeholder="form.carNoStr" type="text" v-model="form.carNo"></van-field>
            </van-cell-group>
          </div>
          <div class="stick" v-else>
            <ul>
              <li>
                <span>联系姓名：</span>
                <span>{{form.name}}</span>
              </li>
              <li>
                <span>联系方式：</span>
                <span>{{form.phone}}</span>
              </li>
              <li>
                <span>车牌号：</span>
                <span>{{form.carNoStr}}</span>
              </li>
            </ul>
            <qrcode class="code" v-if="form.qrcodeStr" :src="form.qrcodeStr"></qrcode>
            <!-- <van-image class="code" :src="require('@/assets/images/temp/qrcode.png')"></van-image> -->
          </div>
        </div>
        <!-- 已设计 -->
        <div v-if="!isFirst">
          <div class="form" v-if="!state">
            <van-cell-group class="no-border no-back">
              <van-field label="联系人" :placeholder="form.name" type="text" v-model="form.realname"></van-field>
            </van-cell-group>
            <van-cell-group class="no-border no-back">
              <van-field label="联系方式" :placeholder="form.phone" type="text" v-model="form.mobile"></van-field>
            </van-cell-group>
            <van-cell-group class="no-border no-back">
              <van-field label="车牌号" :placeholder="form.carNoStr" type="text" v-model="form.carNo"></van-field>
            </van-cell-group>
          </div>
          <div class="stick" v-if="state">
            <ul>
              <span class="stick-icon">【示例】</span>
              <li>
                <span>联系姓名：</span>
                <span>{{form.realname}}</span>
              </li>
              <li>
                <span>联系方式：</span>
                <span>{{form.mobile}}</span>
              </li>
              <li>
                <span>车牌号：</span>
                <span>{{form.carNo}}</span>
              </li>
            </ul>
            <qrcode class="code" v-if="form.qrcodeStr" :src="form.qrcodeStr"></qrcode>
          </div>
        </div>
      </div>
    </div>
    <!-- 未设计 -->
    <div v-if="isFirst">
      <van-button type="primary" @click="handleOne" v-if="state" class="large-button">设计</van-button>
      <van-button
        v-else
        type="primary"
        @click="getSubmit"
        class="large-button"
      >{{!state?'点击生成':'编辑'}}</van-button>
      <p class="grey pd-15">还没有属于自己的挪车贴哦～，</p>
      <p class="grey pd-15">点击“设计”按钮去拥有自己的挪车贴吧！</p>
    </div>
    <!-- 已设计 -->
    <div v-if="!isFirst">
      <van-button v-if="state" type="primary" @click="handleOne" class="large-button">{{'编辑'}}</van-button>
      <van-button v-else type="primary" @click="getSubmit" class="large-button">{{'修改'}}</van-button>
      <p v-if="state" class="grey pd-15">长按图片可保存至相册哦~</p>
    </div>
  </div>
</template>
<script>
import { mPattern, carParttern } from "@/assets/js/rules";
import qrcode from "@/components/qrcode";
export default {
  name: "CarStick",
  components: { qrcode },
  data() {
    return {
      heightChange: true,
      docmHeight: document.documentElement.clientHeight, // 默认屏幕高度
      showHeight: document.documentElement.clientHeight, // 实时屏幕高度
      state: true, // 是否生成挪车贴
      isFirst: true, // 第一次访问
      form: {
        realname: "",
        mobile: "",
        carNo: "",
        name: "咸鱼头",
        phone: "15212551937",
        carNoStr: "浙DC8858"
      },
      img: "",
      backNo: ''
    };
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.heightChange = false;
      } else {
        this.heightChange = true;
      }
    },
    "form.carNo"(t) {
      if (this.backNo === t) {
        return;
      }
      if (t) {
        this.form.carNo = t.toUpperCase();
        this.backNo = t;
      }
    }
  },
  computed: {},
  async mounted() {
    window.onresize = () =>
      (() => {
        this.showHeight = document.body.clientHeight;
      })();
    await this.getImg();
    this.getMsg();
  },
  methods: {
    // move_car_stick/moveCarStick/get
    async getMsg() {
      this.$loading("加载中");
      let result = await this.request("/move_car_stick/moveCarStick/get", {});
      if (result.code === 0) {
        //  code :1004  信息不存在
        // 接口通过说明已经 设置过
        this.isFirst = false;
        this.form = {
          ...this.form,
          ...result.data,
          qrcodeStr: `${process.env.VUE_APP_BASE_SHARE_API}/index.html#/carNum?id=${result.data.id}`
        };
        this.$loadingClose();
      } else if (result.code === 1004) {
        this.$loadingClose();
        this.isFirst = true;
      } else {
        this.$loadingClose();
        this.isFirst = true;
      }
    },
    // move_car_stick/moveCarStickPic/get
    async getImg() {
      let result = await this.request(
        "/move_car_stick/moveCarStickPic/get",
        {}
      );
      if (result.code === 0) {
        this.img = result.data.img;
        // console.log(this.list);
      }
    },
    // 提交表单
    async getSubmit() {
      if (this.state) {
        this.state = false;
      } else {
        if (this.testParam(this.form)) {
          console.log("success");

          // move_car_stick/moveCarStick/design

          let result = await this.request(
            "/move_car_stick/moveCarStick/design",
            { ...this.form }
          );
          if (result.code === 0) {
            // this.img = result.data.img;
            // console.log(this.list);

            this.state = true;
            setTimeout(() => this.$error("保存成功"), 100);
            this.getMsg();
          }
        }
      }
    },
    // 验证码表单
    testParam(param) {
      if (!param.name) {
        this.$error("请输入姓名");
        return false;
      } else if (!param.phone) {
        this.$error("请输入手机号");
        return false;
      } else if (!mPattern.test(param.phone)) {
        this.$error("手机号格式有误");
        return false;
      } else if (!param.carNo) {
        this.$error("请输入车牌号");
        return false;
      } else if (!carParttern.test(param.carNo)) {
        this.$error("车牌号格式有误");
        return false;
      } else {
        return true;
      }
    },
    // 设计挪车贴
    handleOne() {
      // this.isFirst = !this.isFirst;
      this.state = false;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.CarStick {
  font-size: 12px;
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border-width: 0;
  }
  .grey {
    color: #979797;
  }
  .pd-15 {
    text-align: center;
  }
  .car-stick {
    height: 55vh;
    .in-car-stick {
      top: 20px;
      width: 80%;
      .cl();
      position: relative;
    }
    .car-img {
      width: 100%;
      height: 308px;
    }
    .form {
      width: 70%;
      min-height: 32vh;
      .center();
      padding: 20px;
      border-radius: 5px;
      background: #fff;
      /deep/.van-field__label {
        width: 70px;
      }
      .van-cell {
        padding: 10px;
        position: relative;
        &::after {
          position: absolute;
          content: "";
          display: block;
          width: 65%;
          right: 0;
          bottom: 0;
          height: 1px;
          background: #eee;
        }
      }
    }
    .stick {
      width: 70%;
      height: 32vh;
      top: 15px;
      .cl();
      border-radius: 5px;
      ul {
        padding-left: 15%;
        position: relative;
        .stick-icon {
          position: absolute;
          left: -18px;
          top: 2px;
          color: #fff;
        }
        li {
          color: #fff;
          line-height: 22px;
        }
      }
      .code {
        width: 120px;
        height: 120px;
        margin: @pad auto;
        display: block;
        border: 20px solid #fff;
        border-radius: 10px;
        /deep/img {
          width: 100%;
          height: 100%;
          // border-radius: 10px;
        }
      }
    }
  }
  .large-button {
    width: 80%;
    margin: 20px auto;
    display: block;
  }
}
</style>